"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.buildStakeCreateAccountInstructions = exports.buildStakeSplitInstructions = exports.buildStakeWithdrawInstructions = exports.buildStakeUndelegateInstructions = exports.buildStakeDelegateInstructions = exports.buildCreateAssociatedTokenAccountInstruction = exports.getStakeAccountAddressWithSeed = exports.getStakeAccountMinimumBalanceForRentExemption = exports.getMaybeVoteAccount = exports.getMaybeTokenAccount = exports.findAssociatedTokenAccountPubkey = exports.addSignatureToTransaction = exports.buildTokenTransferInstructions = exports.buildTransferInstructions = exports.getTransactions = exports.toStakeAccountWithInfo = exports.toTokenAccountWithInfo = void 0;
var web3_js_1 = require("@solana/web3.js");
var lodash_1 = require("lodash");
var spl_token_1 = require("@solana/spl-token");
var account_1 = require("./account");
var utils_1 = require("../../utils");
var parser_1 = require("./account/parser");
var MEMO_PROGRAM_ID = "MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr";
function toTokenAccountWithInfo(onChainAcc) {
    var parsedInfo = onChainAcc.account.data.parsed.info;
    var info = (0, account_1.parseTokenAccountInfo)(parsedInfo);
    return { onChainAcc: onChainAcc, info: info };
}
exports.toTokenAccountWithInfo = toTokenAccountWithInfo;
function toStakeAccountWithInfo(onChainAcc) {
    if ("parsed" in onChainAcc.account.data) {
        var parsedInfo = onChainAcc.account.data.parsed.info;
        var info = (0, parser_1.parseStakeAccountInfo)(parsedInfo);
        return { onChainAcc: onChainAcc, info: info };
    }
    return undefined;
}
exports.toStakeAccountWithInfo = toStakeAccountWithInfo;
function getTransactionsBatched(address, untilTxSignature, api) {
    return __asyncGenerator(this, arguments, function getTransactionsBatched_1() {
        var signatures, batchSize, _loop_1, _a, _b, signaturesInfoBatch, e_1_1;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, __await(api.getSignaturesForAddress(address, {
                        until: untilTxSignature,
                        limit: 100
                    }))];
                case 1:
                    signatures = _d.sent();
                    batchSize = 100;
                    _loop_1 = function (signaturesInfoBatch) {
                        var transactions, txsDetails;
                        return __generator(this, function (_e) {
                            switch (_e.label) {
                                case 0: return [4 /*yield*/, __await(api.getParsedConfirmedTransactions(signaturesInfoBatch.map(function (tx) { return tx.signature; })))];
                                case 1:
                                    transactions = _e.sent();
                                    txsDetails = transactions.reduce(function (acc, tx, index) {
                                        var _a;
                                        if (tx && !((_a = tx.meta) === null || _a === void 0 ? void 0 : _a.err) && tx.blockTime) {
                                            acc.push({
                                                info: signaturesInfoBatch[index],
                                                parsed: tx
                                            });
                                        }
                                        return acc;
                                    }, []);
                                    return [4 /*yield*/, __await(txsDetails)];
                                case 2: return [4 /*yield*/, _e.sent()];
                                case 3:
                                    _e.sent();
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 7, 8, 9]);
                    _a = __values((0, lodash_1.chunk)(signatures, batchSize)), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [3 /*break*/, 6];
                    signaturesInfoBatch = _b.value;
                    return [5 /*yield**/, _loop_1(signaturesInfoBatch)];
                case 4:
                    _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a["return"])) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    });
}
function getTransactionsGen(address, untilTxSignature, api) {
    return __asyncGenerator(this, arguments, function getTransactionsGen_1() {
        var _a, _b, txDetailsBatch, e_2_1;
        var e_2, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 7, 8, 13]);
                    _a = __asyncValues(getTransactionsBatched(address, untilTxSignature, api));
                    _d.label = 1;
                case 1: return [4 /*yield*/, __await(_a.next())];
                case 2:
                    if (!(_b = _d.sent(), !_b.done)) return [3 /*break*/, 6];
                    txDetailsBatch = _b.value;
                    return [5 /*yield**/, __values(__asyncDelegator(__asyncValues(txDetailsBatch)))];
                case 3: return [4 /*yield*/, __await.apply(void 0, [_d.sent()])];
                case 4:
                    _d.sent();
                    _d.label = 5;
                case 5: return [3 /*break*/, 1];
                case 6: return [3 /*break*/, 13];
                case 7:
                    e_2_1 = _d.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 13];
                case 8:
                    _d.trys.push([8, , 11, 12]);
                    if (!(_b && !_b.done && (_c = _a["return"]))) return [3 /*break*/, 10];
                    return [4 /*yield*/, __await(_c.call(_a))];
                case 9:
                    _d.sent();
                    _d.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    if (e_2) throw e_2.error;
                    return [7 /*endfinally*/];
                case 12: return [7 /*endfinally*/];
                case 13: return [2 /*return*/];
            }
        });
    });
}
function getTransactions(address, untilTxSignature, api) {
    return (0, utils_1.drainSeqAsyncGen)(getTransactionsGen(address, untilTxSignature, api));
}
exports.getTransactions = getTransactions;
var buildTransferInstructions = function (_a) {
    var sender = _a.sender, recipient = _a.recipient, amount = _a.amount, memo = _a.memo;
    var fromPublicKey = new web3_js_1.PublicKey(sender);
    var toPublicKey = new web3_js_1.PublicKey(recipient);
    var instructions = [
        web3_js_1.SystemProgram.transfer({
            fromPubkey: fromPublicKey,
            toPubkey: toPublicKey,
            lamports: amount
        }),
    ];
    if (memo) {
        var memoIx = new web3_js_1.TransactionInstruction({
            keys: [],
            programId: new web3_js_1.PublicKey(MEMO_PROGRAM_ID),
            data: Buffer.from(memo)
        });
        instructions.push(memoIx);
    }
    return instructions;
};
exports.buildTransferInstructions = buildTransferInstructions;
var buildTokenTransferInstructions = function (command) {
    var ownerAddress = command.ownerAddress, ownerAssociatedTokenAccountAddress = command.ownerAssociatedTokenAccountAddress, amount = command.amount, recipientDescriptor = command.recipientDescriptor, mintAddress = command.mintAddress, mintDecimals = command.mintDecimals, memo = command.memo;
    var ownerPubkey = new web3_js_1.PublicKey(ownerAddress);
    var destinationPubkey = new web3_js_1.PublicKey(recipientDescriptor.tokenAccAddress);
    var instructions = [];
    var mintPubkey = new web3_js_1.PublicKey(mintAddress);
    if (recipientDescriptor.shouldCreateAsAssociatedTokenAccount) {
        instructions.push(spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mintPubkey, destinationPubkey, new web3_js_1.PublicKey(recipientDescriptor.walletAddress), ownerPubkey));
    }
    instructions.push(spl_token_1.Token.createTransferCheckedInstruction(spl_token_1.TOKEN_PROGRAM_ID, new web3_js_1.PublicKey(ownerAssociatedTokenAccountAddress), mintPubkey, destinationPubkey, ownerPubkey, [], amount, mintDecimals));
    if (memo) {
        instructions.push(new web3_js_1.TransactionInstruction({
            keys: [],
            programId: new web3_js_1.PublicKey(MEMO_PROGRAM_ID),
            data: Buffer.from(memo)
        }));
    }
    return instructions;
};
exports.buildTokenTransferInstructions = buildTokenTransferInstructions;
var addSignatureToTransaction = function (_a) {
    var tx = _a.tx, address = _a.address, signature = _a.signature;
    tx.addSignature(new web3_js_1.PublicKey(address), signature);
    return tx;
};
exports.addSignatureToTransaction = addSignatureToTransaction;
function findAssociatedTokenAccountPubkey(ownerAddress, mintAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var ownerPubKey, mintPubkey;
        return __generator(this, function (_a) {
            ownerPubKey = new web3_js_1.PublicKey(ownerAddress);
            mintPubkey = new web3_js_1.PublicKey(mintAddress);
            return [2 /*return*/, spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mintPubkey, ownerPubKey)];
        });
    });
}
exports.findAssociatedTokenAccountPubkey = findAssociatedTokenAccountPubkey;
var getMaybeTokenAccount = function (address, api) { return __awaiter(void 0, void 0, void 0, function () {
    var accInfo, tokenAccount;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.getAccountInfo(address)];
            case 1:
                accInfo = _a.sent();
                tokenAccount = accInfo !== null && "parsed" in accInfo.data
                    ? (0, account_1.tryParseAsTokenAccount)(accInfo.data)
                    : undefined;
                return [2 /*return*/, tokenAccount];
        }
    });
}); };
exports.getMaybeTokenAccount = getMaybeTokenAccount;
function getMaybeVoteAccount(address, api) {
    return __awaiter(this, void 0, void 0, function () {
        var accInfo, voteAccount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.getAccountInfo(address)];
                case 1:
                    accInfo = _a.sent();
                    voteAccount = accInfo !== null && "parsed" in accInfo.data
                        ? (0, account_1.tryParseAsVoteAccount)(accInfo.data)
                        : undefined;
                    return [2 /*return*/, voteAccount];
            }
        });
    });
}
exports.getMaybeVoteAccount = getMaybeVoteAccount;
function getStakeAccountMinimumBalanceForRentExemption(api) {
    return api.getMinimumBalanceForRentExemption(web3_js_1.StakeProgram.space);
}
exports.getStakeAccountMinimumBalanceForRentExemption = getStakeAccountMinimumBalanceForRentExemption;
function getStakeAccountAddressWithSeed(_a) {
    var fromAddress = _a.fromAddress, seed = _a.seed;
    return __awaiter(this, void 0, void 0, function () {
        var pubkey;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(new web3_js_1.PublicKey(fromAddress), seed, web3_js_1.StakeProgram.programId)];
                case 1:
                    pubkey = _b.sent();
                    return [2 /*return*/, pubkey.toBase58()];
            }
        });
    });
}
exports.getStakeAccountAddressWithSeed = getStakeAccountAddressWithSeed;
function buildCreateAssociatedTokenAccountInstruction(_a) {
    var mint = _a.mint, owner = _a.owner, associatedTokenAccountAddress = _a.associatedTokenAccountAddress;
    var ownerPubKey = new web3_js_1.PublicKey(owner);
    var mintPubkey = new web3_js_1.PublicKey(mint);
    var associatedTokenAccPubkey = new web3_js_1.PublicKey(associatedTokenAccountAddress);
    var instructions = [
        spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mintPubkey, associatedTokenAccPubkey, ownerPubKey, ownerPubKey),
    ];
    return instructions;
}
exports.buildCreateAssociatedTokenAccountInstruction = buildCreateAssociatedTokenAccountInstruction;
function buildStakeDelegateInstructions(_a) {
    var authorizedAccAddr = _a.authorizedAccAddr, stakeAccAddr = _a.stakeAccAddr, voteAccAddr = _a.voteAccAddr;
    var tx = web3_js_1.StakeProgram.delegate({
        authorizedPubkey: new web3_js_1.PublicKey(authorizedAccAddr),
        stakePubkey: new web3_js_1.PublicKey(stakeAccAddr),
        votePubkey: new web3_js_1.PublicKey(voteAccAddr)
    });
    return tx.instructions;
}
exports.buildStakeDelegateInstructions = buildStakeDelegateInstructions;
function buildStakeUndelegateInstructions(_a) {
    var authorizedAccAddr = _a.authorizedAccAddr, stakeAccAddr = _a.stakeAccAddr;
    var tx = web3_js_1.StakeProgram.deactivate({
        authorizedPubkey: new web3_js_1.PublicKey(authorizedAccAddr),
        stakePubkey: new web3_js_1.PublicKey(stakeAccAddr)
    });
    return tx.instructions;
}
exports.buildStakeUndelegateInstructions = buildStakeUndelegateInstructions;
function buildStakeWithdrawInstructions(_a) {
    var authorizedAccAddr = _a.authorizedAccAddr, stakeAccAddr = _a.stakeAccAddr, amount = _a.amount, toAccAddr = _a.toAccAddr;
    var tx = web3_js_1.StakeProgram.withdraw({
        authorizedPubkey: new web3_js_1.PublicKey(authorizedAccAddr),
        stakePubkey: new web3_js_1.PublicKey(stakeAccAddr),
        lamports: amount,
        toPubkey: new web3_js_1.PublicKey(toAccAddr)
    });
    return tx.instructions;
}
exports.buildStakeWithdrawInstructions = buildStakeWithdrawInstructions;
function buildStakeSplitInstructions(_a) {
    var authorizedAccAddr = _a.authorizedAccAddr, stakeAccAddr = _a.stakeAccAddr, seed = _a.seed, amount = _a.amount, splitStakeAccAddr = _a.splitStakeAccAddr;
    // HACK: switch to split_with_seed when supported by @solana/web3.js
    var splitIx = web3_js_1.StakeProgram.split({
        authorizedPubkey: new web3_js_1.PublicKey(authorizedAccAddr),
        lamports: amount,
        stakePubkey: new web3_js_1.PublicKey(stakeAccAddr),
        splitStakePubkey: new web3_js_1.PublicKey(splitStakeAccAddr)
    }).instructions[1];
    if (splitIx === undefined) {
        throw new Error("expected split instruction");
    }
    var allocateIx = web3_js_1.SystemProgram.allocate({
        accountPubkey: new web3_js_1.PublicKey(splitStakeAccAddr),
        basePubkey: new web3_js_1.PublicKey(authorizedAccAddr),
        programId: web3_js_1.StakeProgram.programId,
        seed: seed,
        space: web3_js_1.StakeProgram.space
    });
    return [allocateIx, splitIx];
}
exports.buildStakeSplitInstructions = buildStakeSplitInstructions;
function buildStakeCreateAccountInstructions(_a) {
    var fromAccAddress = _a.fromAccAddress, stakeAccAddress = _a.stakeAccAddress, seed = _a.seed, amount = _a.amount, stakeAccRentExemptAmount = _a.stakeAccRentExemptAmount, delegate = _a.delegate;
    var fromPubkey = new web3_js_1.PublicKey(fromAccAddress);
    var stakePubkey = new web3_js_1.PublicKey(stakeAccAddress);
    var tx = web3_js_1.StakeProgram.createAccountWithSeed({
        fromPubkey: fromPubkey,
        stakePubkey: stakePubkey,
        basePubkey: fromPubkey,
        seed: seed,
        lamports: amount + stakeAccRentExemptAmount,
        authorized: {
            staker: fromPubkey,
            withdrawer: fromPubkey
        }
    });
    tx.add(web3_js_1.StakeProgram.delegate({
        authorizedPubkey: fromPubkey,
        stakePubkey: stakePubkey,
        votePubkey: new web3_js_1.PublicKey(delegate.voteAccAddress)
    }));
    return tx.instructions;
}
exports.buildStakeCreateAccountInstructions = buildStakeCreateAccountInstructions;
//# sourceMappingURL=web3.js.map